<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :bodyStyle="bodyStyle"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :okButtonProps="{ props: {disabled:disableSubmit} }"
    cancelText="关闭">
        <a-card title="明细">
          <div class="ant-table ant-table-scroll-position-left ant-table-middle ant-table-bordered ant-table-empty">
            <div class="ant-table-content"><!---->
              <div class="ant-table-body">
                <table class="">
                  <colgroup>
                    <col style="width: 50px; min-width: 50px;">
                    <col style="width: 350px; min-width: 300px;">
                    <col>
                    <col style="width: 100px; min-width: 100px;">
                  </colgroup>
                  <thead class="ant-table-thead">
                  <tr>
                    <th class="ant-table-align-center ant-table-row-cell-break-word"
                        style="text-align: center;"><span class="ant-table-header-column">
                                <div><span class="ant-table-column-title">序号</span><span
                                  class="ant-table-column-sorter"></span></div>
                            </span></th>
                    <th class="ant-table-align-center" style="text-align: center;"><span
                      class="ant-table-header-column">
                                <div><span class="ant-table-column-title">土地用途</span><span
                                  class="ant-table-column-sorter"></span></div>
                            </span></th>
                    <th class="ant-table-align-center" style="text-align: center;"><span
                      class="ant-table-header-column">
                                <div><span class="ant-table-column-title">出让年限</span><span
                                  class="ant-table-column-sorter"></span></div>
                            </span></th>
                    <th class="ant-table-align-center ant-table-row-cell-break-word ant-table-row-cell-last"
                        style="text-align: center;"><span class="ant-table-header-column">
                                <div><span class="ant-table-column-title">操作</span><span
                                  class="ant-table-column-sorter"></span></div>
                            </span></th>
                  </tr>
                  </thead>
                  <tbody class="ant-table-tbody" >
                  <tr v-for="(item, i) in landDetailList" style="text-align: center">
                    <td>{{ i + 1 }}</td>
                    <td>
                      <j-dict-select-tag  placeholder="请选择土地用途" dictCode="em_land_userfor"
                                         v-model="item.landUserfor"
                                         :disabled="disableSubmit" style="width:100%"/>
                    </td>
                    <td>
                      <a-input-number placeholder="出让年限"  style="width: 100%" :readOnly="disableSubmit" v-model="item.transferYears" />
                    </td>
                    <td>
                      <a v-if="i == 0" @click="addTr(i)" style="color: #3d8610">新增</a>
                      <a v-if="i != 0" @click="delTr(item,i)">删除</a>
                    </td>
                  </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
       </a-card>
    <a-card title="信息">
      <a-row>
        <a-col :span="4">
          <a-col :span="23">
            <a-form-item class="itemInput">
              <a-input-number placeholder="请输入数字"  style="width: 100%"   :readOnly="disableSubmit" v-model="landlList.plotRatioBe" />
            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="4">
          <a-col :span="23">
            <a-form-item class="itemInput">
              <a-select  v-model="landlList.plotRatioBeSymbol" placeholder="请选择符号" :disabled="disableSubmit"  style="width: 100%">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="<">&lt;</a-select-option>
                <a-select-option value="=">=</a-select-option>
                <a-select-option value="≤">≤</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="8">
          <a-col :span="7" class="labelTop"  style="margin-right: 5px">
            <span>容积率</span>
          </a-col>
          <a-col :span="16">
            <a-form-item class="itemInput">
              <a-select  v-model="landlList.plotRatioAfSymbol" placeholder="请选择符号" :disabled="disableSubmit" style="width: 99%">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="<">&lt;</a-select-option>
                <a-select-option value="=">=</a-select-option>
                <a-select-option value="≤">≤</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="4">
          <a-col :span="23">
            <a-form-item class="itemInput">
              <a-input-number placeholder="请输入数字"  style="width: 100%"   :readOnly="disableSubmit" v-model="landlList.plotRatioAf" />
            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="4">
          <a-col :span="23">
            <a-form-item class="itemInput">
              <a-input placeholder="其他说明"  style="width: 100%"   :readOnly="disableSubmit" v-model="landlList.plotRatioRemark" />
            </a-form-item>
          </a-col>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="4">
          <a-col :span="23">
            <a-form-item class="itemInput">
              <a-input-number placeholder="请输入数字"  style="width: 100%"   :readOnly="disableSubmit" v-model="landlList.buildingDensityBe" />
            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="4">
          <a-col :span="23">
            <a-form-item class="itemInput">
              <a-select  v-model="landlList.buildingDensityBeSymbol" placeholder="请选择符号" :disabled="disableSubmit"  style="width: 100%">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="<">&lt;</a-select-option>
                <a-select-option value="=">=</a-select-option>
                <a-select-option value="≤">≤</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="8">
          <a-col :span="7" class="labelTop" style="margin-right: 5px" >
            <span>建筑密度</span>
          </a-col>
          <a-col :span="16">
            <a-form-item class="itemInput">
              <a-select  v-model="landlList.buildingDensityAfSymbol" placeholder="请选择符号" :disabled="disableSubmit" style="width: 100%">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="<">&lt;</a-select-option>
                <a-select-option value="=">=</a-select-option>
                <a-select-option value="≤">≤</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="4">
          <a-col :span="23">
            <a-form-item class="itemInput">
              <a-input-number placeholder="输入符号"  style="width: 85%"   :readOnly="disableSubmit" v-model="landlList.buildingDensityAf" />
              %
            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="4">
          <a-col :span="23">
            <a-form-item class="itemInput">
              <a-input placeholder="其他说明"  style="width: 100%"   :readOnly="disableSubmit" v-model="landlList.buildingDensityRemark" />
            </a-form-item>
          </a-col>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="4">
          <a-col :span="23">
            <a-form-item class="itemInput">
              <a-input-number placeholder="请输入数字"  style="width: 100%"   :readOnly="disableSubmit" v-model="landlList.greenRatinBe" />
            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="4">
          <a-col :span="23">
            <a-form-item class="itemInput">
              <a-select  v-model="landlList.greenRatinBeSymbol" placeholder="请选择符号" :disabled="disableSubmit"  style="width: 100%">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="<">&lt;</a-select-option>
                <a-select-option value="=">=</a-select-option>
                <a-select-option value="≤">≤</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="8">
          <a-col :span="7" class="labelTop" style="margin-right: 5px"  >
            <span>绿地率</span>
          </a-col>
          <a-col :span="16">
            <a-form-item class="itemInput">
              <a-select  v-model="landlList.greenRatinAfSymbol" placeholder="请选择符号" :disabled="disableSubmit" style="width: 100%">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="<">&lt;</a-select-option>
                <a-select-option value="=">=</a-select-option>
                <a-select-option value="≤">≤</a-select-option>
              </a-select>

            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="4">
          <a-col :span="23">
            <a-form-item class="itemInput">
              <a-input-number placeholder="请输入数字"  style="width: 85%"   :readOnly="disableSubmit" v-model="landlList.greenRatinAf" />
              %
            </a-form-item>

          </a-col>
        </a-col>
        <a-col :span="4">
          <a-col :span="23">
            <a-form-item class="itemInput">
              <a-input placeholder="其他说明"  style="width: 100%"   :readOnly="disableSubmit" v-model="landlList.greenRatinRemark" />
            </a-form-item>
          </a-col>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="4">
          <a-col :span="23">
            <a-form-item class="itemInput">
              <a-input-number placeholder="请输入数字"  style="width: 100%"   :readOnly="disableSubmit" v-model="landlList.buildingHeightLimitBf" />
            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="4">
          <a-col :span="23">
            <a-form-item class="itemInput">
              <a-select  v-model="landlList.buildingHeightLimitBfSymbol" placeholder="请选择符号" :disabled="disableSubmit"  style="width: 100%">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="<">&lt;</a-select-option>
                <a-select-option value="=">=</a-select-option>
                <a-select-option value="≤">≤</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="8">
          <a-col :span="7" class="labelTop" style="margin-right: 5px" >
            <span>建筑限高</span>
          </a-col>
          <a-col :span="16">
            <a-form-item class="itemInput">
              <a-select  v-model="landlList.buildingHeightLimitAfSymbol" placeholder="请选择符号" :disabled="disableSubmit" style="width: 100%">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="<">&lt;</a-select-option>
                <a-select-option value="=">=</a-select-option>
                <a-select-option value="≤">≤</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="4">
          <a-col :span="23">
            <a-form-item class="itemInput">
              <a-input-number placeholder="请输入数字"  style="width: 85%"   :readOnly="disableSubmit" v-model="landlList.buildingHeightLimitAf" />
              m
            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="4">
          <a-col :span="23">
            <a-form-item class="itemInput">
              <a-input placeholder="其他说明"  style="width: 100%"   :readOnly="disableSubmit" v-model="landlList.buildingHeightLimitRemark" />
            </a-form-item>
          </a-col>
        </a-col>
      </a-row>
    </a-card>
  </a-modal>
</template>

<script>
import Vue from "vue";
import {ACCESS_TOKEN} from "@/store/mutation-types";
import moment from "moment/moment";
import {postAction} from "@api/manage";

export default {
  name: "ProjectLandAddLandModal",
  data () {
    return {
      tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
      title: "操作",
      bodyStyle:{
        padding: "0",
        overflow:"auto",
        // height:(window.innerHeight-100)+"px"
        height:"400px"
      },
      landnum:0,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      landlList:{
      },//地块明细信息
      landDetailList:[{}],
      delLandDetailList:[],
    }
  },
  computed: {
  },
  methods:{
    close () {
      //this.$emit('close');
      this.visible = false;
    },
    handleCancel () {
      this.visible = false;
    },
    add() {
      this.visible = true;
      this.model={};
      this.landlList= {}
      this.landDetailList=[{}];
      this.delLandDetailList=[];
    },
    edit(record) {
      this.visible = true;
      this.model={};
      this.landlList= record;
      this.landDetailList=record.landDetailList;
      this.delLandDetailList=[];
    },
    //新增地块
    //保存
    handleOk(){
      this.landlList.landDetailList=this.landDetailList;
      if(this.landlList.landCode==null ||this.landlList.landCode=='')
      {
        let num=this.landnum+1;
        this.landlList.landCode='code'+num;
      }
      console.log("this.landlList",this.landlList);
      this.$emit('setDataSourceLand',this.landlList)
      this.close();
    },
    addTr(index) {
      //新增一栏tr
      let trItem = {}
      Object.assign(trItem, this.landDetailList[index][this.landDetailList[index].length - 1])
      this.landDetailList.push(trItem)
    },
    delTr(item, index) {
      this.landDetailList.splice(index, 1);
      if(item.id)
      {
        this.delLandDetailList.push(item.id);
      }
    },
  }
}
</script>

<style scoped>
.labelTop{
  margin-top: 10px;
  text-align: right;
  color:#262626;
}
</style>